<template>
    <div style="width: 100vw; height: 100vh; display: flex; justify-content: center; align-items: center;">
      <el-card class="box-card" style="width: 600px; margin: auto; border: none; box-shadow: none;">
        <div style="text-align:center;">
          <div
            v-for="(card, idx) in cardList"
            :key="card.id || idx"
            style="margin-bottom: 32px; border-bottom: 1px solid #eee; padding-bottom: 24px;"
          >
            <!-- 卡密 -->
            <div style="margin-bottom: 20px; text-align:left; margin-left:100px;">
              <span style="margin-right: 20px;">卡密：</span>
              <span>{{ card.car_mine }}</span>
              <el-button type="text" icon="el-icon-document-copy" style="margin-left: 8px;" @click="copyCardNo(card.car_mine)"></el-button>
            </div>
            <!-- 激活码类型 -->
            <div class="row">
              <div class="label">激活码类型</div>
              <div class="value" style="flex:2;">
                {{cardprices.find(p => p.id === card.car_mode)?.name || '未知类型'}}
              </div>
            </div>
            <!-- 提取人 -->
            <!-- <div class="row">
              <div class="label">提取人</div>
              <div class="value" style="flex:2;">{{ card.user }}</div>
            </div> -->
            <!-- 实收金额 -->
            <div class="row">
              <div class="label">实收金额</div>
              <div class="value" style="flex:2;">{{ card.receipts }}</div>
              <div class="edit">
                <el-button type="text" icon="el-icon-edit" @click="editField(idx, 'receipts')"></el-button>
              </div>
            </div>
            <!-- 备注 -->
            <div class="row">
              <div class="label">备注</div>
              <div class="value" style="flex:2;">{{ card.remark }}</div>
              <div class="edit">
                <el-button type="text" icon="el-icon-edit" @click="editField(idx, 'remark')"></el-button>
              </div>
            </div>
          </div>
          <el-button type="primary" style="margin-top: 32px; width: 108px;" @click="exportTxt">保存</el-button>
        </div>
      </el-card>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CardInfo',
    data() {
      return {
        // 示例数组，实际请用你的后端数据替换
        cardList: [
          
        ],
        cardprices:[]
      }
    },
    methods: {
        async cardPriceList(){
            try {
                const res = await this.$axios.post('/carmine/cardprice', {
                })
                this.cardprices = res.data;
            } catch (err) {
                console.log(err);
            }
        },
      copyCardNo(cardNo) {
        this.$message.success('卡密已复制');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(cardNo);
        }
      },
      editField(idx, field) {
        this.$prompt(`请输入新的${field === 'amount' ? '实收金额' : '备注'}`, '编辑', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValue: this.cardList[idx][field]
        }).then(({ value }) => {
          this.$set(this.cardList[idx], field, value);
          this.$message.success('修改成功');
        });
      },
      save() {
        this.$message.success('保存成功！');
        // 提交所有卡密数据
      },
      exportTxt() {
        // 导出为 txt
        let txt = this.cardList.map(card =>
            `卡密: ${card.car_mine}\n激活码类型: ${this.cardprices.find(p => p.id === card.car_mode)?.name || '未知类型'}\n实收金额: ${card.receipts}\n备注: ${card.remark}\n`
        ).join('\n-----------------\n');
        let blob = new Blob([txt], { type: 'text/plain;charset=utf-8' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = '卡密导出.txt';
        link.click();
        window.URL.revokeObjectURL(link.href);
        this.$message.success('TXT文件已导出');
        }
    },
    mounted() {
        // 1. 从 query 里拿到 json 字符串
        const updatedCardStr = this.$route.query.updatedCard;
        if (updatedCardStr) {
            try {
                // 2. 解析为数组
                const cards = JSON.parse(updatedCardStr);
                // 3. 如果是单个对象，转成数组
                this.cardList = Array.isArray(cards) ? cards : [cards];
                console.log(this.cardList);
            } catch(e) {
                console.error("解析卡密数据失败", e);
            }
        }
        this.cardPriceList();
    }
  }
  </script>
  
  <style scoped>
  .box-card {
    background: transparent;
    box-shadow: none;
    border: none;
  }
  .row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    margin-left:100px;
    margin-right:100px;
    line-height: 40px;
  }
  .label {
    width: 100px;
    text-align: right;
    color: #333;
    margin-right: 18px;
    font-weight: 500;
  }
  .value {
    color: #333;
    min-width: 120px;
    text-align: left;
  }
  .edit {
    width: 30px;
    text-align: left;
  }
  </style>